var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row mt-0 mt-lg-3"},[_c('div',{staticClass:"col-xl-3"},[_c('Card',{attrs:{"card":_vm.card,"titleLink":"Security","seeMore":true}})],1),_c('div',{staticClass:"col-xl-9"},[_c('Tabs',{attrs:{"tabs":_vm.tabs,"object":_vm.interaction}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }